// Imaton Consult - Frontend JavaScript

// Подключение модулей
require('../Lead/Lead');
require('../Auth/Auth');
require('../Profile/Profile');
require('../Booking/Booking');
require('../Waitlist/Waitlist');
require('../Application/Application');
require('../DiplomaPopup/DiplomaPopup');
require('../VideoPopup/VideoPopup');

// Модули кабинета психолога
require('../PsyAuth/PsyAuth');
require('../PsyProfile/PsyProfile');
require('../PsySchedule/PsySchedule');
require('../PsyAppointments/PsyAppointments');
require('../MltTags/MltTags');
require('../PsyBilling/PsyBilling');
require('../Blog/Blog');

// Mobile menu functionality
$(document).ready(function() {
	// Burger menu open
	$('.header__burger').click(function() {
		$('body').addClass('no-scroll');
		$('.header__nav').addClass('active');
	});

	// Close menu button
	$('.header__nav-close').click(function() {
		$('body').removeClass('no-scroll');
		$('.header__nav').removeClass('active');
	});

	// Close menu on click outside
	$(document).click(function(e) {
		if ($('.header__nav').hasClass('active')) {
			var menu = $('.header__nav, .header__burger');
			if (!menu.is(e.target) && menu.has(e.target).length === 0) {
				$('body').removeClass('no-scroll');
				$('.header__nav').removeClass('active');
			}
		}
	});

	// Close menu on resize to desktop
	$(window).resize(function() {
		if (window.matchMedia('(min-width: 1024px)').matches && $('.header__nav').hasClass('active')) {
			$('body').removeClass('no-scroll');
			$('.header__nav').removeClass('active');
		}
	});

	// Header scroll effect
	$(window).scroll(function() {
		if ($(this).scrollTop() > 50) {
			$('.header').addClass('header--scrolled');
		} else {
			$('.header').removeClass('header--scrolled');
		}
	});

	// Корректный доскролл при переходе с другой страницы с якорем
	if (window.location.hash && window.location.hash.length > 1) {
		var initialHash = window.location.hash.substring(1);
		var scrollToInitialHash = function() {
			var $target = $('#' + initialHash);
			if (!$target.length) $target = $('a[name="' + initialHash + '"]');
			if (!$target.length) return;
			var headerHeight = $('.header').outerHeight() || 80;
			window.scrollTo(0, $target.offset().top - headerHeight);
		};
		// первый раз — сразу, второй — после загрузки картинок/шрифтов (layout может сдвинуться)
		scrollToInitialHash();
		$(window).on('load', scrollToInitialHash);
	}

	// Smooth scroll to anchors
	$('a[href*="#"]').click(function(e) {
		var headerHeight = $('.header').outerHeight() || 80;
		var href = $(this).attr('href');
		var hash = href.indexOf('#') !== -1 ? href.substring(href.indexOf('#') + 1) : '';

		if (!hash) return;

		// Check if it's a link to another page with anchor
		var isExternalAnchor = href.indexOf('/') !== -1 && href.indexOf('#') > 0;
		var currentPath = window.location.pathname;
		var linkPath = href.split('#')[0];

		// If link points to different page, let browser handle it
		if (isExternalAnchor && linkPath !== '' && linkPath !== currentPath && linkPath !== '/') {
			return;
		}

		// Find target element by id or name
		var $target = $('#' + hash);
		if (!$target.length) {
			$target = $('a[name="' + hash + '"]');
		}

		if ($target.length) {
			e.preventDefault();
			var destination = $target.offset().top - headerHeight;
			$('html, body').animate({ scrollTop: destination }, 300);

			// Close mobile menu if open
			if ($('.header__nav').hasClass('active')) {
				$('body').removeClass('no-scroll');
				$('.header__nav').removeClass('active');
			}

			// Update URL hash without jumping
			if (history.pushState) {
				history.pushState(null, null, '#' + hash);
			}
		}
	});
});
